import React from 'react';
import StatusMetersPage from './StatusMetersPage';

export default function Accepted() {
  return (
    <StatusMetersPage status="Accepted" title="Commission Accepted" showViewMore />
  );
}
